<template>
    <v-dialog
        v-model="$store.state.transacting.marginComment"
        max-width="650px"
    >
        <v-card>
            <v-toolbar color="secondary" dense dark>
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Margin Comments
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.transacting.marginComment = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-textarea v-model="marginComment" rows="8"></v-textarea>
                <v-row justify="end">
                    <v-col cols="2">
                        <v-btn color="primary" @click="saveComment">Save</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['ShiftDetail'],
    data: function() {
        return {
            marginComment: null
        };
    },

    mounted() {
        console.log(this.ShiftDetail);
        this.marginComment = this.ShiftDetail[0].MarginAnalysis;
    },
    methods: {
        saveComment: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                MarginAnalysis: this.marginComment
            };
            axios
                .put('shift-detail/' + this.ShiftDetail[0].ShiftDetail, params)
                .then(response => {
                    console.log(response.data);
                    this.$store.state.transacting.watchMargin = true;
                    this.$store.state.transacting.marginComment = false;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
